import logger from './logger';

export default class CookieHelper {
  constructor() {
    this.appCookieName = "license-management-app";
  }

  setCookie = (value, time = null, days = 7) => {
    let expires = "";
    let date = new Date();
    
    if (days) {
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = `; expires=${date.toUTCString()}`;
    } else if (time) {
      date = new Date(time * 1000);
      expires = `; expires=${date.toUTCString()}`;
    }
    
    try {
      const jsonValue = JSON.stringify(value);
      const encodedValue = btoa(jsonValue);
      document.cookie = `${this.appCookieName}=${encodedValue || ""}${expires}; path=/; secure; samesite=strict`;
    } catch (error) {
      logger.error("Error setting cookie:", error);
    }
  };

  getCookie = (name = this.appCookieName) => {
    try {
      const nameEQ = `${name}=`;
      const ca = document.cookie.split(";");
      
      for (let i = 0; i < ca.length; i += 1) {
        let c = ca[i];
        while (c.charAt(0) === " ") c = c.substring(1, c.length);
        
        if (c.indexOf(nameEQ) === 0) {
          const encodedValue = c.substring(nameEQ.length, c.length);
          const decodedValue = atob(encodedValue);
          return JSON.parse(decodedValue);
        }
      }
    } catch (error) {
      logger.error("Error getting cookie:", error);
      // Clear corrupted cookie
      this.clearCookie(name);
    }
    return null;
  };

  clearCookie = (name = this.appCookieName) => {
    try {
      document.cookie = `${name}=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT; secure; samesite=strict`;
    } catch (error) {
      logger.error("Error clearing cookie:", error);
    }
  };

  // Method to set multiple cookies for different data types
  setUserCookie = (userData, days = 7) => {
    this.setCookie(userData, null, days);
  };

  // Method to get user data from cookie
  getUserCookie = () => {
    return this.getCookie();
  };

  // Method to clear all app-related cookies
  clearAllCookies = () => {
    this.clearCookie();
    this.clearCookie('access_token');
  };
}
